export const th = {
    translation: {
        b: {
            cancel: 'ยกเลิก',
            confirm: 'ยืนยัน',
            send: 'ส่ง',
            done: 'เสร็จสิ้น',
            close: 'ปิด',
            clear: 'ล้าง',
            copy_link: 'คัดลอกลิงก์',
            export: 'ส่งออก',
            delete: 'ลบ',
            delete_confirm: 'ยืนยันการลบ',
            duplicate: 'ทำซ้ำ',
            share: 'แชร์',
            sign_in: 'ลงชื่อเข้าใช้',
            sign_up: 'สมัครสมาชิก',
            email_address: 'ที่อยู่อีเมล',
            yes: 'ใช่',
            no: 'ไม่ใช่'
        },
        m_languages: {
            title: 'ภาษา',
            subtitle: 'เลือกภาษา'
        },
        m_feedback: {
            feature: {
                name: 'คำขอฟีเจอร์',
                desc: 'ขาดฟีเจอร์ที่คุณต้องการอยู่หรือไม่? บอกเราได้เลย — ไอเดียของคุณสำคัญมาก'
            },
            feedback: {
                name: 'ข้อเสนอแนะ',
                desc: 'ข้อเสนอแนะของคุณมีความหมายกับเรามาก — กรุณาฝากข้อความสั้น ๆ ไว้'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'ขอบคุณสำหรับข้อเสนอแนะของคุณ!',
                desc: 'ขอบคุณที่สละเวลาแบ่งปันความคิด — สิ่งนี้ช่วยให้เราพัฒนาให้ดียิ่งขึ้น'
            },
            feedback: {
                name: 'ขอบคุณสำหรับความคิดเห็นของคุณ!',
                desc: 'ขอบคุณที่สละเวลาแบ่งปันความคิด — สิ่งนี้ช่วยให้เราพัฒนาให้ดียิ่งขึ้น'
            }
        },
        m_diagram_details: {
            name_place: 'ป้อนชื่อโปรเจกต์',
            desc_place: 'ป้อนคำอธิบายโปรเจกต์'
        },
        m_quick_share: {
            title: 'แชร์ด่วน',
            subtitle: '(การแชร์ลิงก์แบบอิงคิวรี)'
        },
        m_export_img: {
            title: 'ส่งออกภาพ'
        },
        m_export_code: {
            title: 'ส่งออกโค้ด {{db_engine}}',
            download_file: 'ดาวน์โหลดไฟล์',
            copy_code: 'คัดลอกโค้ด'
        },
        m_sign_in_remind: {
            title: 'ขอบคุณที่ลองใช้ DB Design',
            subtitle: 'ลงชื่อเข้าใช้หรือสมัครสมาชิกเพื่อเพิ่มจำนวนตารางสูงสุด บันทึกไดอะแกรม และปลดล็อกฟีเจอร์เพิ่มเติม'
        },
        m_sign_in_restrict: {
            title: 'ลงชื่อเข้าเพื่อทำได้มากขึ้นในแอป',
            subtitle: 'ลงชื่อเข้าใช้หรือสมัครสมาชิกเพื่อเพิ่มขีดจำกัดของตาราง บันทึกไดอะแกรม และปลดล็อกฟีเจอร์เพิ่มเติม'
        },
        m_new_diagram: {
            title: 'ไดอะแกรมใหม่',
            subtitle: 'เลือกเอนจินฐานข้อมูล',
            open_diagram: 'เปิดไดอะแกรม'
        },
        m_keyboard_shortcuts: {
            title: 'ปุ่มลัดแป้นพิมพ์',
            ctrl_left: {
                title1: 'การควบคุม',
                title2: '(ซ้าย)',
                items: {
                    mouse_sel: 'เลือกด้วยเมาส์ / โหมดมือ',
                    table: 'ตาราง',
                    line: 'เส้น',
                    area: 'พื้นที่',
                    note: 'โน้ต',
                    comment: 'ความคิดเห็น',
                    pen: 'ปากกา',
                    undo: 'เลิกทำ',
                    redo: 'ทำซ้ำ'
                }
            },
            ctrl_top_left: {
                title1: 'การควบคุม',
                title2: '(มุมซ้ายบน)',
                items: {
                    export_img: 'ส่งออกภาพ',
                    search: 'ค้นหา',
                    editor_panel: 'แผงตัวแก้ไข'
                }
            },
            ctrl_bottom_right: {
                title1: 'การควบคุม',
                title2: '(มุมขวาล่าง)',
                items: {
                    minimap: 'มินิแมป',
                    zoom_in: 'ขยาย',
                    zoom_out: 'ย่อ',
                    zoom_100: 'ซูม 100%'
                }
            },
            ctx_tab: {
                title1: 'เมนูตามบริบท',
                title2: '(ตาราง)',
                items: {
                    dupl_tab: 'ทำซ้ำตาราง',
                    del_tab: 'ลบตาราง'
                }
            },
            ctx_del_tab: {
                title1: 'เมนูตามบริบท',
                title2: '(ลบตาราง)',
                items: {
                    yes: 'ใช่',
                    no: 'ไม่ใช่'
                }
            },
            ctx_tab_col: {
                title1: 'เมนูตามบริบท',
                title2: '(คอลัมน์ของตาราง)',
                items: {
                    add_col_below: 'เพิ่มคอลัมน์ด้านล่าง',
                    focus_col_above: 'ย้ายโฟกัสไปยังคอลัมน์ด้านบน',
                    focus_col_below: 'ย้ายโฟกัสไปยังคอลัมน์ด้านล่าง',
                    move_col_up: 'ย้ายคอลัมน์ขึ้น',
                    move_col_down: 'ย้ายคอลัมน์ลง',
                    dupl_col: 'ทำซ้ำคอลัมน์',
                    del_col: 'ลบคอลัมน์'
                }
            },
            ctx_line: {
                title1: 'เมนูตามบริบท',
                title2: '(เส้น)',
                items: {
                    del_line: 'ลบเส้น'
                }
            },
            ctx_area: {
                title1: 'เมนูตามบริบท',
                title2: '(พื้นที่)',
                items: {
                    dupl_area: 'ทำซ้ำพื้นที่',
                    del_area: 'ลบพื้นที่'
                }
            },
            ctx_multi: {
                title1: 'เมนูตามบริบท',
                title2: '(เลือกหลายรายการ)',
                items: {
                    select_all: 'เลือกองค์ประกอบทั้งหมด',
                    create_area_for_select_els: 'สร้างพื้นที่สำหรับองค์ประกอบที่เลือก',
                    dupl_select_els: 'ทำซ้ำองค์ประกอบที่เลือก',
                    del_select_els: 'ลบองค์ประกอบที่เลือก'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'เลือกด้วยเมาส์',
                table: 'ตาราง',
                line: 'เส้น',
                area: 'พื้นที่',
                note: 'โน้ต (เร็ว ๆ นี้)',
                comment: 'ความคิดเห็น (เร็ว ๆ นี้)',
                pen: 'ปากกา',
                undo: 'เลิกทำ',
                redo: 'ทำซ้ำ'
            },
            ctrl_top_left: {
                logo: 'หมายเหตุ: ที่นี่คือแซนด์บ็อกซ์ (พื้นที่ทดสอบ)',
                name: 'ข้อมูลไดอะแกรม',
                editor: 'ตัวแก้ไข (เร็ว ๆ นี้)',
                search: 'การค้นหา (เร็ว ๆ นี้)',
                export: 'ตัวเลือกการส่งออก',
                view_mode: 'โหมดมุมมอง',
                zoom_to_fit: 'ปรับพอดีกับหน้าจอ'
            },
            ctrl_top_right: {
                feature_req: 'คำขอฟีเจอร์',
                sign_in: 'ลงชื่อเข้าใช้',
                quick_share: 'แชร์ด่วน'
            },
            ctrl_bottom_right: {
                full_screen: 'เต็มหน้าจอ',
                minimap: 'มินิแมป',
                zoom_out: 'ย่อ',
                zoom_100: 'ซูม 100%',
                zoom_in: 'ขยาย',
                info: 'ข้อมูลและแหล่งข้อมูล'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'ค่าเริ่มต้น',
                        blue: 'สีน้ำเงิน',
                        green: 'สีเขียว',
                        red: 'สีแดง',
                        purple: 'สีม่วง',
                        violet: 'สีไวโอเลต'
                    },
                    borders: {
                        none: 'ไม่มี',
                        solid: 'เส้นทึบ',
                        dashed: 'เส้นประ',
                        dotted: 'เส้นจุด'
                    },
                    color: 'สี',
                    border: 'เส้นขอบ',
                    description: 'คำอธิบาย',
                    description_table_place: 'คำอธิบายตาราง',
                    description_column_place: 'คำอธิบายคอลัมน์',
                    description_line_place: 'คำอธิบายเส้น',
                    description_note_place: 'คำอธิบายโน้ต',
                    description_area_place: 'คำอธิบายพื้นที่',
                    description_pen_place: 'คำอธิบายปากกา',
                    hide_menu: 'ซ่อนเมนู',
                    show_menu: 'แสดงเมนู'
                },
                tab_col: {
                    add_col_below: 'เพิ่มคอลัมน์ด้านล่าง',
                    add_col_above: 'เพิ่มคอลัมน์ด้านบน',
                    key: 'Key',
                    keys: {
                        none: 'ไม่มี',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'ไม่มี',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'ย้ายคอลัมน์ลง',
                    move_col_up: 'ย้ายคอลัมน์ขึ้น',
                    more_functions: 'ฟังก์ชันเพิ่มเติม'
                },
                line: {
                    change_connects: 'เปลี่ยนตัวเชื่อมต่อ',
                    connects: {
                        empty: 'ว่าง',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'กรององค์ประกอบ'
                },
                multi: {
                    filter: 'กรองการเลือก',
                    create_area: 'สร้างพื้นที่'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'เต็ม',
            keys_only: 'เฉพาะคีย์',
            names_only: 'เฉพาะชื่อ'
        },
        dropdown_ctrl_export: {
            export_img: 'ส่งออกภาพ',
            export_code: 'ส่งออกโค้ด SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'ลงชื่อเข้าใช้',
            new_project: 'โปรเจกต์ใหม่',
            keyboard_shortcuts: 'ปุ่มลัดแป้นพิมพ์',
            languages: 'ภาษา'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'ข้อเสนอแนะ',
            keyboard_shortcuts: 'ปุ่มลัดแป้นพิมพ์',
            languages: 'ภาษา',
            homepage: 'หน้าแรก'
        },
        n: {
            default: 'กำลังโหลด…',
            file_ready_to_download: 'ไฟล์พร้อมให้ดาวน์โหลดแล้ว',
            code_copied: 'คัดลอกโค้ดแล้ว',
            link_copied: 'คัดลอกลิงก์แล้ว',
            please_enter_message: 'โปรดป้อนข้อความ',
            invalid_email: 'อีเมลไม่ถูกต้อง',
            something_wrong_contact: 'เกิดข้อผิดพลาด โปรดโหลดหน้าอีกครั้งหรือติดต่อเรา',
            something_wrong: 'เกิดข้อผิดพลาด โปรดโหลดหน้าอีกครั้ง',
            sending: 'กำลังส่ง…',
            request_sent: 'ส่งคำขอแล้ว ขอบคุณ!'
        }
    }
};

export const thMeta = {
    lang_origin: 'ภาษาไทย',
    lang_eng: 'Thai',
    lang_code: 'th',
};
